// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import "@popperjs/core";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "jquery/dist/jquery.slim";
import "chartkick/chart.js"

require("components/header");
require('vet/animal/form');
require('vet/fisical_exam/form');
require('vet/ecocardiogram/form');
require('saas/applied_form/create');
require('saas/applied_form/edit');
require('saas/self_applied_form/new');
require('saas/self_applied_form/questions');
require('saas/self_applied_form/find');

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// axios config
var axios = require('axios')
global.axios = global.axios = axios;
